'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Moment } from 'moment';
const PredefinedGraphsContext = createContext(undefined);
export function PredefinedGraphsProvider({
  children
}) {
  const [graphsData, setGraphsData] = useState({});
  const [dateRange, setDateRangeState] = useState({
    start: null,
    end: null
  });
  const setDateRange = range => {
    const prevRange = dateRange;
    setDateRangeState(range);
    // Clear cached data when date range actually changes
    if (prevRange.start?.format('YYYY-MM-DD') !== range.start?.format('YYYY-MM-DD') || prevRange.end?.format('YYYY-MM-DD') !== range.end?.format('YYYY-MM-DD')) {
      setGraphsData({});
    }
  };
  const setGraphData = (sectionId, graphId, data) => {
    setGraphsData(prev => ({
      ...prev,
      [sectionId]: {
        ...prev[sectionId],
        [graphId]: data
      }
    }));
  };
  const getGraphData = (sectionId, graphId) => {
    return graphsData[sectionId]?.[graphId] || null;
  };
  const clearSectionData = sectionId => {
    setGraphsData(prev => {
      const updated = {
        ...prev
      };
      delete updated[sectionId];
      return updated;
    });
  };
  const clearAllData = () => {
    setGraphsData({});
  };
  return <PredefinedGraphsContext.Provider value={{
    graphsData,
    dateRange,
    setDateRange,
    setGraphData,
    getGraphData,
    clearSectionData,
    clearAllData
  }}>
            {children}
        </PredefinedGraphsContext.Provider>;
}
export function usePredefinedGraphs() {
  const context = useContext(PredefinedGraphsContext);
  if (context === undefined) {
    throw new Error('usePredefinedGraphs must be used within a PredefinedGraphsProvider');
  }
  return context;
}